import type { StateTree as DashStateTree } from '@makemydeal/dr-dash-types';
import { featureToggleSelectors, sharedBootstrapSelectors } from '@makemydeal/dr-shared-store';

import type { StateTree } from '../types/StateTree';

export const isMvRedesignActive = (state: DashStateTree): boolean =>
    sharedBootstrapSelectors.wasBootstrapSuccessful(state) && featureToggleSelectors.isMvRedesignEnabled(state);

export const isRecentDealsShown = (state: StateTree): boolean => Boolean(state.recentDeals?.showRecentDeals);
